import makeIssueReasonValue from "utils/topicparameters/make_basic_issue_reason_value";

export default makeIssueReasonValue;
